import { useEffect } from 'react';

import {
  Hits,
  useStats,
} from 'react-instantsearch';

import NoResults from './no-results';

import * as styles from './styles/search.module.scss';

import type { IHitWrapper } from './types';


const HitWrapper = ({ escapeHTML, hitComponent, tabs, setShowMetaElements, ...rest }: IHitWrapper) => {
  const { nbHits, query } = useStats(rest);
  useEffect(() => {
    if (setShowMetaElements) {
      setShowMetaElements(nbHits > 0);
    }
  }, [nbHits, setShowMetaElements]);
  if (nbHits > 0) {
    return (
      <div className={styles.tabResults}>
        <Hits escapeHTML={escapeHTML} hitComponent={hitComponent} {...rest} />
      </div>
    );
  }
  return <NoResults query={query} />;
};

export default HitWrapper;
